<template>
  <div class="container">
    <div @click="$emit('close')" class="close">❌</div>
    <p>
      Vous ouvrez le coffret et vous y découvrez deux éléments à l'intérieur : un cryptex et une illustration encadrée.
      Vous vous installez dans votre bureau pour profiter de sa luminosité et mieux les inspecter. Le cryptex est
      impressionnant. Avec ses huit anneaux en pierre gravés. Vous savez maintenant quel est votre nouvel objectif :
      trouver le mot qui le déverrouillera. L'illustration doit être au cœur de la résolution de cette énigme !
    </p>
  </div>
</template>

<script>
export default {
  name: "OfficeIntro",
  components: {},
};
</script>

<style scoped>
.container {
  background: rgb(220, 220, 220);
  padding: 5px 20px;
  overflow: scroll;
  position: relative;
}
.button-wrapper {
  font-family: "VT323", monospace;
  text-align: center;
  color: white;
  background: darkred;
  line-height: 30px;
}
.button-wrapper:hover {
  opacity: 0.85;
  cursor: pointer;
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.close:hover {
  cursor: pointer;
}
</style>
